// Suggested starter questions. Clicking a chip sets the question and
// submits immediately. The model now decides response shape (comparative
// JSON vs prose) based on the question itself — no per-chip mode hint.

import type { ManifestoLanguage } from '../../lib/useManifestoQuery';
import './SuggestedChips.css';

interface Chip {
  en: string;
  mt: string;
}

const CHIPS: Chip[] = [
  {
    en: 'What does each party propose on income tax?',
    mt: "X'jipproponi kull partit dwar it-taxxa fuq id-dħul?",
  },
  {
    en: 'Compare positions on healthcare',
    mt: 'Qabbel il-pożizzjonijiet dwar is-saħħa',
  },
  {
    en: 'How does each address the cost of living?',
    mt: "Kif jindirizza kull partit l-għoli tal-ħajja?",
  },
  {
    en: 'Which has the better plan for young families?',
    mt: "Liema għandu l-aħjar pjan għall-familji żgħażagħ?",
  },
  {
    en: 'What does each propose on traffic and transport?',
    mt: "X'jipproponi kull partit dwar it-traffiku u t-trasport?",
  },
  {
    en: 'Compare positions on energy',
    mt: "Qabbel il-pożizzjonijiet dwar l-enerġija",
  },
  {
    en: 'What does each say about Gozo?',
    mt: "X'jgħid kull manifest dwar Għawdex?",
  },
  {
    en: "Compare each party's approach to climate and the environment",
    mt: "Qabbel l-approċċ ta' kull partit lejn il-klima u l-ambjent",
  },
];

const HEADING: Record<ManifestoLanguage, string> = {
  en: 'Try one of these',
  mt: 'Ipprova waħda minn dawn',
};

export default function SuggestedChips({
  language,
  onPick,
  disabled,
}: {
  language: ManifestoLanguage;
  onPick: (q: { question: string }) => void;
  disabled: boolean;
}) {
  return (
    <div className="mf-chips">
      <p className="mf-chips__heading">{HEADING[language]}</p>
      <div className="mf-chips__row">
        {CHIPS.map((chip) => {
          const text = language === 'mt' ? chip.mt : chip.en;
          return (
            <button
              key={chip.en}
              type="button"
              className="mf-chip"
              disabled={disabled}
              onClick={() => onPick({ question: text })}
            >
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
